export const TENANT_CODES = {
  UPGRAD: "UPGRAD",
  STUDY_ABROAD: "STUDY_ABROAD",
  HUBSPOT: "HBSPT",
  UG_LIFT: "UGLIFT",
  KH: "KH",
  LC: "LC",
};
export const TENANT_KEY = "current_tenant";
export const API_TENANT_UPGRAD = "UGB2C";

export const MSGS = {
  MISSING_TENANT: "Select the tenant before proceeding",
};

const setTenantInCache = (info) => {
  localStorage.setItem(TENANT_KEY, JSON.stringify(info));
};

const getTenantFromCache = () => {
  return localStorage.getItem(TENANT_KEY);
};

const clearTenantInfoFromCache = () => {
  localStorage.removeItem(TENANT_KEY);
};

export const TENANT_UTILS = {
  setTenantInCache,
  getTenantFromCache,
  clearTenantInfoFromCache,
};

/**
 * Backend tenant code used by the refund APIs. upGrad is stored as UGB2C in
 * application-service; every other tenant uses its own code. No tenant selected
 * behaves as upGrad, matching the dashboard's historical default.
 */
export const toApiTenantCode = (tenantCode) => {
  if (!tenantCode) return API_TENANT_UPGRAD;
  return tenantCode === TENANT_CODES.UPGRAD ? API_TENANT_UPGRAD : tenantCode;
};
